export const irrigacao = {
  area: '',
  dataInicio: '',
  tiposSistemas: [],
  outroSistema: '',
  fontesAgua: [],
  outroFonteAgua: '',
  captacaoLicenciada: '',
  quantidadeAguaAnual: ''
}



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/praticas/genericos.js